<template>
    <div>
        <div class="swap-modal-align-center">
            <span
                class="sg-vrm-icon_012_alarm-32px sg-color-red dci__warning__icon vrm-modal__title-icon"
            ></span>
            <div
                class="vrm-modal__title"
                v-html="
                    $t(`general.confirm_replace_modal.title`, {
                        i18nFallback: 'You are about to replace your GX device.',
                    })
                "
            ></div>
        </div>
        <div class="vrm-modal__content swap-modal-align-center">
            <div
                class="vrm-modal__text"
                v-html="
                    $t(`general.confirm_replace_modal.consequences`, {
                        i18nFallback:
                            'The historical data from your original installation will be preserved. The replacement GX device will begin updating to this installation once installed.',
                    })
                "
            ></div>
        </div>

        <div class="vrm-modal__content">
            <div class="installation-selection-header replace-device-modal">
                <div
                    class="installation-selection__title"
                    v-html="
                        $t(`general.confirm_replace_modal.current_installation`, {
                            i18nFallback: 'Current Installation',
                        })
                    "
                ></div>
                <div class="arrow-space"></div>
                <div
                    class="installation-selection__title"
                    v-html="
                        $t(`general.confirm_replace_modal.replacement_installation`, {
                            i18nFallback: 'Replacement installation',
                        })
                    "
                ></div>
            </div>

            <div class="installation-selection replace-device-modal">
                <div class="pick-installation">
                    <p
                        class="installation-selection__title"
                        v-html="
                            $t(`general.confirm_replace_modal.current_installation`, {
                                i18nFallback: 'Current installation',
                            })
                        "
                    ></p>
                    <div class="installation-selection__current-installation">
                        <vrm-installation-card
                            :installation="swapInstallationsModel.currentInstallation"
                            :extended="true"
                        />
                    </div>
                </div>
                <div class="arrow-container">
                    <i class="sg-vrm-icon_126_arrow-right-32px arrow"></i>
                </div>
                <div class="pick-installation">
                    <p
                        class="installation-selection__title"
                        v-html="
                            $t(`general.confirm_replace_modal.replacement_installation`, {
                                i18nFallback: 'Replacement GX device',
                            })
                        "
                    ></p>
                    <div class="installation-selection__current-installation">
                        <vrm-installation-card
                            :installation="swapInstallationsModel.selectedInstallation"
                            :extended="true"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="vrm-modal__content swap-modal-align-center">
            <div class="sg-custom-check-and-radio sg-custom-check checkmark-container">
                <label
                    class="vrm-fieldset__item__label sg-textfield-label sg-required checkmark-container"
                    for="checkReplacement"
                >
                    <input id="checkReplacement" type="checkbox" @click="tickCheckBox()" />

                    <div class="sg-alternative-display">
                        <div class="sg-icon-check"></div>
                    </div>

                    <span
                        class="sg-textfield-label-caption"
                        v-html="
                            $t(`general.confirm_replace_modal.validate`, {
                                i18nFallback:
                                    'I confirm the GX device in my current installation will be replaced by the replacement GX device..',
                            })
                        "
                    ></span>
                </label>
            </div>

            <div class="vrm-modal__content">
                <button
                    class="sg-btn sg-blue"
                    :disabled="!checkboxValue"
                    @click="setWizardStep(2), tryToTransfer()"
                >
                    {{
                        $t(`general.confirm_replace_modal.confirm_replace`, {
                            i18nFallback: 'Confirm and replace GX device',
                        })
                    }}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { ngInject } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import VrmInstallationCard from '@/vue/components/shared/VrmInstallationCard';
@Component({
    components: {
        VrmInstallationCard,
    },
    props: {
        swapInstallationsModel: {
            type: Object,
        },
        checkboxValue: {
            type: Boolean,
        },
    },
    methods: {
        setWizardStep(value) {
            this.$parent.setWizardStep(value);
        },
        tryToTransfer() {
            this.$parent.tryToTransfer();
        },
        tickCheckBox() {
            this.$parent.tickCheckBox();
        },
    },
})
@AngularLocaleBundle('general')
export default class VrmSwapDevicesStepConfirm extends Vue {
    @ngInject()
    SwapInstallationService;
}
</script>
